module.exports = __webpack_public_path__ + "static/img/Bachelor_010692.dcd8914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010692.jpg
// module id = 218
// module chunks = 0